export default __webpack_public_path__ + "static/media/tengol.d0b647b2.png";